<script setup>
import { computed } from 'vue'

const props = defineProps({
  modified: {
    type: Number,
    default: null,
  },
  created: {
    type: Number,
    default: null,
  },
  menuExpanded: {
    type: Boolean,
    default: false,
  },
})

const lastSaved = computed(() => {
  if (!props.modified || props.modified == '') return false
  if (props.modified == props.created) return false

  const date = new Date(props.modified * 1000)

  const formatted =
    date.toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }) + ' Uhr'

  return formatted
})

const emit = defineEmits(['toggleMenu'])
// document.jsVariables.
</script>

<template>
  <header class="AssessmentHeader">
    <a href="#main" class="AssessmentHeader-skip">Direkt zum Inhalt</a>

    <img
      src="/assets/fraunhofer_logo.svg"
      class="AssessmentHeader-logo"
      width="250"
      height="42"
      alt="Logo: Fraunhofer Gesellschaft"
    />

    <div class="AssessmentHeader-info">
      <strong>Inklusionsmaßnahmen Selbsteinschätzung</strong>
      <span>
        <template v-if="lastSaved">
          Zuletzt gespeichert: {{ lastSaved }}
        </template>
        <template v-else> &nbsp; </template>
      </span>
    </div>

    <button
      class="AssessmentHeader-button"
      :aria-expanded="menuExpanded"
      aria-controls="main-menu"
      @click="emit('toggleMenu')"
    >
      <span class="visually-hidden">Menü</span>
      <svg class="AssessmentHeader-buttonIcon" aria-hidden="true">
        <use :href="menuExpanded ? '#close' : '#hamburger'"></use>
      </svg>
    </button>
  </header>
</template>
